import { pcmBase64ToWavDataUrl } from "../../../utils/blobHelpers";

function containsArabic(text) {
  return /[؀-ۿݐ-ݿࢠ-ࣿ]/.test(text);
}

export async function previewTTS(text, name) {
  if (!text) return;
  const response = await fetch(`${import.meta.env.VITE_TTS_URL || "/heycallcenter/api"}/tts`, {
    method: "POST",
    // Prompt synthesis is metered and priced per tenant, so it needs the session token.
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + (localStorage.getItem("token") || "") },
    body: JSON.stringify({
      lang: containsArabic(text) ? "ar" : "en",
      items: [{ text, name: name || "preview" }],
    }),
  });
  if (!response.ok) {
    let msg = `TTS unavailable (${response.status})`;
    try { const e = await response.json(); msg = e.error || msg; } catch {}
    throw new Error(msg);
  }
  const blobs = await response.json();
  const audio = new Audio(pcmBase64ToWavDataUrl(blobs[0].blobBase64));
  audio.play();
}
